<jhi-spinner *ngIf="circleLoading"></jhi-spinner>

<div class="col-xl">
  <div class="card-wrapper">
    <div class="card card-bg">
      <div class="card-body">
        <div class="container">
        <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span></li>
            <li class="breadcrumb-item" *ngIf="checkListaPrenotazioni()"><a href="javascript:void(0)" (click)="goToListaPrenotazioni()">Lista prenotazioni</a><span class="separator">/</span></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToInserimentoDatiPrenotazione()">Dati prenotazione</a><span class="separator">/</span></li>
            <li class="breadcrumb-item active"><a href="javascript:void(0)">Servizio prenotazione</a></li>
          </ol>
        </nav>
        </div>
        <div style="justify-content: center">
          <div class="container">
            <div class="row" style="justify-content: center">
              <div class="col-xl-10 col-lg-12">
                <div class="card no-after">
                  <div id="custom-card-body" class="card-body my-3 pt-0 pb-0">
                    <div class="d-flex flex-wrap" style="justify-content: center">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-2">
                        <div class="d-flex" style="justify-content: center">
                          <div style="width: 100px">
                            <div class="text-center label lbl-inserimento-dati" jhiTranslate="progressBar.iTuoiDati">I
                              tuoi dati
                            </div>
                            <button class="btn rounded-circle p-1 btn-last-step primary-button" disabled>1</button>
                          </div>
                          <hr class="hr-inserimento-dati"/>
                          <div style="width: 100px">
                            <div class="text-center label lbl-inserimento-dati" jhiTranslate="progressBar.servizio">
                              Servizio
                            </div>
                            <button class="btn rounded-circle p-1 btn-actual-step border-circle" disabled>2</button>
                          </div>
                          <hr class="hr-inserimento-dati"/>
                          <div style="width: 100px">
                            <div class="text-center label lbl-inserimento-dati" jhiTranslate="progressBar.dataOra">Data
                              e ora
                            </div>
                            <button class="btn rounded-circle p-1 btn-next-step " disabled>3</button>
                          </div>
                          <hr class="hr-inserimento-dati"/>
                          <div style="width: 100px">
                            <div class="text-center label lbl-inserimento-dati" jhiTranslate="progressBar.riepilogo">
                              Riepilogo
                            </div>
                            <button class="btn rounded-circle p-1 btn-next-step " disabled>4</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <form class="mt-3" [formGroup]="formSceltaServizio">
            <div class="row" style="justify-content: center">
              <div class="col-xl-10 col-lg-12">
                <div class="card no-after">
                  <div class="card-body mt-0 mb-0 pt-0 pb-0">
                    <div class="d-flex flex-wrap" style="justify-content: center;">
                      <div class="ps-xxl-3 col-xxl-3 col-xl-3 col-lg-12 col-md-12 col-sm-12 p-2 mb-4"
                           joyrideStep="primoStep" [stepContent]="primoStep"
                           [nextTemplate]="nextButton" [prevTemplate]="prevButton">
                        <div class="form-group mb-1 pl-3 pr-3">
                          <div class="select-wrapper custom-wrapper">
                            <label class="bsi-field-required" for="servizioID"
                                   jhiTranslate="form.servizio">Servizio</label>
                            <select #_SELECT_SERVIZI id="servizioID" formControlName="nmServizio" >
                              <option selected hidden disabled value="" jhiTranslate="form.scegli">Scegli un'opzione
                              </option>
                              <option *ngFor="let servizioEr of serviziErogati; index as i" [value]="servizioEr.servizio!.id">
                                {{servizioEr.servizio!.nmServizio}}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="pe-xxl-3 col-xxl-5 col-xl-5 col-lg-12 col-md-12 col-sm-12 p-2 mb-4"
                           joyrideStep="secondoStep" [stepContent]="secondoStep"
                           [nextTemplate]="nextButton" [prevTemplate]="prevButton">
                        <div class="form-group mb-1 pl-3 pr-3">
                          <div class="select-wrapper custom-wrapper">
                            <label class="bsi-field-required" for="ufficioID">Ufficio</label>
                            <select #_SELECT_SEDE formControlName="nmUfficio" id="ufficioID">
                              <option selected disabled hidden value="" jhiTranslate="form.scegli">Scegli un'opzione
                              </option>
                                <optgroup *ngFor="let ufficio of ottieniListaUffici()" [label]="ufficio.sede?.nmSede">
                                  <option [value]="ufficio.id">{{ufficio.nmUfficio}} - {{ufficio.sede?.dlIndirizzo}}</option>
                                </optgroup>
                            </select>
                          </div>
                        </div>
                      </div>
<!--                      <div class="pe-xxl-3 col-xxl-2 col-xl-3 col-lg-12 col-md-12 col-sm-12 p-2 mb-4"
                           joyrideStep="terzoStep" [stepContent]="terzoStep"
                           [nextTemplate]="nextButton" [prevTemplate]="prevButton">
                        <div class="form-group ml-3 mb-1 pl-3 pr-3">
                          <div class="select-wrapper custom-wrapper">
                            <label for="dipendenteID" jhiTranslate="form.operatore">Operatore</label>
                            <select formControlName="nmDipendente" id="dipendenteID">
                              <option class="fw-bold" selected value="" jhiTranslate="form.NessunaPreferenza" [hidden]="getNmDipendente.value === ''">Nessuna preferenza </option>
                              <option class="fw-bold" disabled hidden value="nd"
                                      jhiTranslate="form.NessunaDisponibilita">Nessuna disponibilità
                              </option>
                              <option *ngFor="let dip of dipendenti"
                                      [value]="dip.id">{{dip.nmNome + " " + dip.nmCognome}}</option>
                            </select>
                            <div class="progress progress-indeterminate" *ngIf="lineLoading">
                              <span class="visually-hidden">In elaborazione...</span>
                              <div class="progress-bar" role="progressbar"></div>
                            </div>
                          </div>
                        </div>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="justify-content: center">
              <div class="col-xl-9 col-lg-12">
                <div class="card no-after">
                  <div class="card-body mt-0 mb-0 pt-0 pb-0">
                    <div class="d-flex flex-wrap" style="justify-content: center;">

                      <div class="col-xxl-6 col-xl-8 col-lg-8 col-md-8 col-sm-8 p-2 ms-xxl-3 ps-xxl-3"
                           joyrideStep="quartoStep" [stepContent]="quartoStep"
                           [nextTemplate]="nextButton" [prevTemplate]="prevButton">
                        <div class="map-container custom-wrapper">
                          <div class="map-frame">
                            <div id="map"></div>
                          </div>
                        </div>
                      </div>

                      <div class="col-xxl-3 col-xl-4 col-lg-4 col-md-4 col-sm-4 p-2 me-xxl-3 pe-xxl-3"
                           joyrideStep="quintoStep" [stepContent]="quintoStep"
                           [nextTemplate]="nextButton" [prevTemplate]="prevButton">
                        <div class="form-group custom-wrapper p-1">
                          <label for="noteID" class="active" style="color:#435a70!important;">Note</label>
                          <textarea placeholder="{{'form.noteDaComunicare' | translate}}" formControlName="deNote"
                                    style="resize: none;" maxlength="500" id="noteID" rows="10"></textarea>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" style="justify-content: center">
              <div class="col-xl-10 col-lg-12">
                <div class="card no-after">
                  <div class="card-body mt-4 mb-0 pt-0 pb-0">
                    <div class="d-flex justify-content-between">
                      <button type="button" (click)="goToInserimentoDatiPrenotazione()"
                              class="btn btn-primary primary-button" jhiTranslate="form.indietro">Indietro
                      </button>
                      <button type="button"
                              [ngClass]="{'disabled': formSceltaServizio.invalid || getNmDipendente.disabled}"
                              (click)="goToInserimentoDataOra()" class="btn btn-primary primary-button"
                              jhiTranslate="form.procedi"
                              joyrideStep="sestoStep" [stepContent]="sestoStep"
                              [nextTemplate]="nextButton" [prevTemplate]="prevButton">Procedi
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </form>

        </div>
      </div>
    </div>
  </div>
</div>

<div>
  <button class="btn btn-secondary btn-xs btn-tour" (click)="onTour()">Tour</button>
</div>

<ng-template #nextButton>
  <button class="btn btn-xs" jhiTranslate="tour.button.nextButton">Vai avanti</button>
</ng-template>
<ng-template #prevButton>
  <button class="btn btn-xs" jhiTranslate="tour.button.prevButton">Torna Indietro</button>
</ng-template>
<ng-template #doneButton>
  <button class="btn btn-xs btn-success" jhiTranslate="tour.button.doneButton">Fine</button>
</ng-template>
<ng-template #primoStep>
  <h3 jhiTranslate="tour.scelta-servizi-prenotazione.primoStep-h3">Scegli il servizio desiderato</h3>
  <p jhiTranslate="tour.scelta-servizi-prenotazione.primoStep-p"></p>
</ng-template>
<ng-template #secondoStep>
  <h3 jhiTranslate="tour.scelta-servizi-prenotazione.secondoStep-h3">Scegli la sede desiderata</h3>
  <p jhiTranslate="tour.scelta-servizi-prenotazione.secondoStep-p">Cliccando sul menù a tendina compariranno le varie
    opzioni disponibili</p>
</ng-template>
<ng-template #terzoStep>
  <h3 jhiTranslate="tour.scelta-servizi-prenotazione.terzoStep-h3">Opzionale - Scegli un operatore</h3>
  <p jhiTranslate="tour.scelta-servizi-prenotazione.terzoStep-p">Cliccando sul menù a tendina compariranno le varie
    opzioni disponibili</p>
</ng-template>
<ng-template #quartoStep>
  <h3 jhiTranslate="tour.scelta-servizi-prenotazione.quartoStep-h3">E' possibile visualizzare e selezionare la sede
    direttamente dalla mappa</h3>
  <p></p>
</ng-template>
<ng-template #quintoStep>
  <h3 jhiTranslate="tour.scelta-servizi-prenotazione.quintoStep-h3">Opzionale - Inserisci delle note personalizzate</h3>
  <p jhiTranslate="tour.scelta-servizi-prenotazione.quintoStep-p">Scrivi eventuali informazioni sula prenotazione in
    questione</p>
</ng-template>
<ng-template #sestoStep>
  <h3 jhiTranslate="tour.scelta-servizi-prenotazione.sestoStep-h3">Premi il bottone prosegui per continuare la
    prenotazione</h3>
  <p></p>
</ng-template>

